import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=d997f522&scoped=true&"
import script from "./debug.vue?vue&type=script&lang=js&"
export * from "./debug.vue?vue&type=script&lang=js&"
import style0 from "./debug.vue?vue&type=style&index=0&id=d997f522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d997f522",
  null
  
)

export default component.exports